import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';

const ItemMenuSidebar = (props) => {
    if(props.onClick){
        return (
            <li>
                <a href='/logout' onClick={()=> {props.onClick()}}>
                    <i className="fa fa-map-o"></i> <span>{props.name}</span>
                    <span className="pull-right-container">
                    </span>
                </a>
            </li>
        )
    } else {
        return (
            <li>
                <Link to={props.url}>
                    <i className="fa fa-map-o"></i> <span>{props.name}</span>
                    <span className="pull-right-container">
                    </span>
                </Link>
            </li>
        )
    }
}

const mapStateToProps = (state, props) =>{
    return {...props, usuario: state.usuario};
}

export default withRouter(connect(mapStateToProps)(ItemMenuSidebar))